import { StyledDialog, Transition } from "./styles";
import { StyledDialogTitle } from "./StyledDialogTitle";
import { DialogContent } from "@mui/material";
import { ReactElement } from "react";

interface IProps {
  title: any;
  open: boolean;
  handleClose: () => void;
  children: ReactElement | ReactElement[];
  fullScreen: boolean;
  maxWidth?: any;
  width?: string;
  height?: string;
  sx?: any;
}

export default function AppModal({
  title,
  open,
  handleClose,
  children,
  fullScreen,
  maxWidth = "sm",
  width,
  height,
  sx
}: IProps) {
  return (
    <StyledDialog
      open={open}
      maxWidth={maxWidth}
      fullScreen={fullScreen}
      sx={sx}
      fullWidth
      TransitionComponent={Transition}
      // sx={{
      //   "& .MuiPaper-root": {
      //     height: height || "auto", 
      //   },
      //   ...sx, 
      // }}
      
    >
      <StyledDialogTitle  id="customized-dialog-title" onClose={handleClose}>
        {title}
      </StyledDialogTitle>
      <DialogContent dividers={fullScreen ? false : true}>
        {children}
      </DialogContent>
    </StyledDialog>
  );
}
